import userdata from './userdata';
import auth from './auth';
import companyData from './company-data';
import session from './session';

export default {
  ...auth,
  ...userdata,
  ...companyData,
  ...session,
};
